import {Switch} from "react-vcomponents";
import {BaseComponent, BaseComponentPlus} from "react-vextensions";
import {store} from "../Store/index.js";
import {Me, MeID} from "../Server/DB/users.js";
import {Observer, SubNavBar_Auto} from "web-vcore";
import {HasModPermissions} from "../Server/DB/users/$user.js";
import {ConfigUI} from "./Engine/Config.js";
import {MonitorUI} from "./Tools/Monitor";
import {TrainingUI} from "./Tools/Training";
import React from "react";
import {JourneyUI} from "./Engine/Journey.js";
import {PestUI} from "./Tools/Pest.js";
import {observer_mgl} from "mobx-graphlink";
import {VRUI} from "./Tools/VR.js";
import {EchoHuntUI} from "./Tools/EchoHunt.js";

export const columnWidths = [.64, .06, .12, .18];

export const ToolsPage = observer_mgl(()=>{
	const currentSubpage = store.main.tools.subpage;
	const page = "tools";
	//const subpages = pageTree.children[page].children.VValues();

	return (
		<>
			<SubNavBar_Auto page={page} filter={a=>HasModPermissions(MeID()) || a.key != "training"}/>
			<Switch>
				{/*subpages.map((subpage, index)=>{
					if (index != 0 && currentSubpage != subpage.key) return null;
					return subpage.component;
				})*/}
				<MonitorUI/>
				{currentSubpage == "training" && <TrainingUI/>}
				{currentSubpage == "pest" && <PestUI/>}
				{currentSubpage == "vr" && <VRUI/>}
				{currentSubpage == "echoHunt" && <EchoHuntUI/>}
			</Switch>
		</>
	);
});
